/**
 * Session Setttings Tab
 */
import { Box } from '@mui/material';
// import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles({
  formControl: {
    paddingBottom: 20
  }
});

const SessionSettings = ({ selectedSpeaker, setSelectedSpeaker, selectedMic, setSelectedMic, selectedCamera, setSelectedCamera }) => {
  const classes = useStyles();

  const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);

  useEffect(() => {
    /**
     * Get media devices
     */
    const getDevices = () => {
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        setDevices(devices);
      });
    };

    getDevices();

    // Detect camera/mic change
    navigator.mediaDevices.addEventListener('devicechange', getDevices);
  }, [setSelectedSpeaker, setSelectedMic, setSelectedCamera]);

  const audioOutputDevices = devices?.filter((device) => device.kind === 'audiooutput');

  const audioInputDevices = devices?.filter((device) => device.kind === 'audioinput');

  const videoInputDevices = devices?.filter((device) => device.kind === 'videoinput');

  return (
    <>
      <Box>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">
            <FormattedMessage defaultMessage="Speaker" />
          </FormLabel>
          <RadioGroup aria-label="speaker" name="speaker" value={selectedSpeaker} onChange={(e, value) => setSelectedSpeaker(value)}>
            {audioOutputDevices?.map((device, key) => (
              <FormControlLabel
                key={device.deviceId}
                value={device.deviceId}
                control={<Radio />}
                label={device.label || `Device ${key + 1}`}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      <Box>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">
            <FormattedMessage defaultMessage="Microphone" />
          </FormLabel>
          <RadioGroup aria-label="microphone" name="microphone" value={selectedMic} onChange={(e, value) => setSelectedMic(value)}>
            {audioInputDevices?.map((device, key) => (
              <FormControlLabel
                key={device.deviceId}
                value={device.deviceId}
                control={<Radio />}
                label={device.label || `Device ${key + 1}`}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>

      <Box>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">
            <FormattedMessage defaultMessage="Camera" />
          </FormLabel>
          <RadioGroup
            aria-label="camera"
            name="camera"
            value={selectedCamera || (videoInputDevices?.length && videoInputDevices[0].deviceId)}
            onChange={(e, value) => setSelectedCamera(value)}
          >
            {videoInputDevices?.map((device, key) => (
              <FormControlLabel
                key={device.deviceId}
                value={device.deviceId}
                control={<Radio />}
                label={device.label || `Device ${key + 1}`}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Box>
    </>
  );
};

export default SessionSettings;
